module.exports = __webpack_public_path__ + "img/jindou_icon.84045c2f.png";